export const COMPONENT_NAME = "auth-layout";
